module.exports = __webpack_public_path__ + "static/img/icon_sf_tab.064dc35.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_sf_tab.png
// module id = xh/e
// module chunks = 1